import { isOrderReady } from './orderStatus';

// Seed silently on first load; one chime for a batch of new/ready orders.
export const orderSnapshot = (orders) => new Map(orders.map(order => [order.name, isOrderReady(order)]));
export const hasOrderNotification = (previous, current) => previous !== null &&
    [...current].some(([name, ready]) => !previous.has(name) || (ready && !previous.get(name)));

export const createOrderChime = () => {
    let context;
    return {
        async play() {
            const AudioContext = window.AudioContext || window.webkitAudioContext;
            if (!AudioContext) return false;
            try {
                context = context || new AudioContext();
                if (context.state === 'suspended') await context.resume();
                if (context.state !== 'running') return false;
                // Soft attack/release avoids clicks; two clear, non-overlapping notes.
                [784, 1046.5].forEach((frequency, index) => {
                    const start = context.currentTime + index * 0.38;
                    const oscillator = context.createOscillator();
                    const gain = context.createGain();
                    oscillator.type = 'sine';
                    oscillator.frequency.value = frequency;
                    gain.gain.setValueAtTime(0.0001, start);
                    gain.gain.exponentialRampToValueAtTime(0.4, start + 0.035);
                    gain.gain.exponentialRampToValueAtTime(0.0001, start + 0.36);
                    oscillator.connect(gain);
                    gain.connect(context.destination);
                    oscillator.onended = () => { oscillator.disconnect(); gain.disconnect(); };
                    oscillator.start(start);
                    oscillator.stop(start + 0.37);
                });
                return true;
            } catch (_) { return false; }
        },
        close() { context?.close().catch(() => {}); context = undefined; },
    };
};
